import type { SegmentTrackNewsletterSignupEvent } from "@beautypie/segment/Track/NewsletterSignup";
import { track } from "tracking";

import { NewsletterSignupLocationType } from "../helpers";

export enum SignupType {
  OutOfStock = "OOS",
  Waitlist = "Waitlist",
  Newsletter = "Newsletter"
}

export const trackSegmentNewsLetterSignup = (
  signupType: SegmentTrackNewsletterSignupEvent["properties"]["signup_type"],
  locationType = NewsletterSignupLocationType.Page.valueOf()
): void => {
  const data: SegmentTrackNewsletterSignupEvent = {
    event: "Newsletter Signup",
    properties: {
      signup_type: signupType,
      location_type:
        locationType as SegmentTrackNewsletterSignupEvent["properties"]["location_type"]
    }
  };
  track(data);
};
